import React from 'react';
import { Button, Typography, Result } from 'antd';
import { useNavigate } from 'react-router-dom';

const { Text } = Typography;

function SuccessTransfer() {
  const navigate = useNavigate();
  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#F8FAFC' }}>
      <Result
        status="success"
        title="Transfer Successful!"
        subTitle={
          <Text style={{ color: '#64748B' }}>
            Your mortgage payment has been processed. The updated balance will reflect shortly.
          </Text>
        }
        extra={[
          <Button
            key="history"
            type="primary"
            size="large"
            onClick={() => navigate('/transfer/history')}
            style={{ background: '#1C2B4A', borderColor: '#1C2B4A', fontWeight: 600 }}
          >
            View Transfer History
          </Button>,
          <Button
            key="home"
            size="large"
            onClick={() => navigate('/accounts/summary')}
            style={{ fontWeight: 600 }}
          >
            Back to Accounts
          </Button>,
        ]}
      />
    </div>
  );
}

export default SuccessTransfer;
